export default import.meta.ROLLUP_FILE_URL_6bp_5It$EfTQ8f$omStdjw;